import Cookies from "js-cookie";

export enum StorageKeys {
  AuthAccessToken = "__smeetz-pos--auth-at",
  AuthRefreshToken = "__smeetz-pos--auth-rt",
  AuthExpiresIn = "__smeetz-pos--auth-ei",
  Language = "__smeetz-pos--lang",
  AuthAccessTokenB2B = "__smeetz--auth-at",
  AuthRefreshTokenB2B = "__smeetz--auth-rt",
  AuthExpiresInB2B = "__smeetz--auth-ei",
  SmtzAuthToken = "__smeetz-pos--auth-gql",
}

export enum LocalStorageKeys {
  PosConfig = "__smeetz-pos--config",
  Booking = "__smeetz-booking",
  PssExtensions = "__smeetz-pss-ext",
  CashFloat = "__smeetz-cash-float",
  Device = "__smeetz-device",
  Receipt = "__smeetz-receipt",
  PrinterConfig = "__smeetz-printer",
  timeslot_availabilities = "timeslots_availability",
  retail_availabilities = "retail_availability",
  Logs = "__logs",
  ReceiptPrinter = "__smeetz-receipt-printer",
  TicketPrinter = "__smeetz-ticket-printer",
  App = "__smeetz-app",
  Common = "__smeetz-common",
  Order = "__smeetz-order",
  Log = "__smeetz-log",
  Fiskaly = "__smeetz-fiskaly",
  manualHardwareUuid = "manualHardCodedHardwareUuid",
  Customer = "__smeetz-customer",
  PreventRefresh = "__smeetz-prevent-refresh",
  ExternalVouchers = "__smeetz-external-vouchers",
  Offers = "__smeetz-offers",
  Compliance = "__smeetz-compliance",
  DataMigration = "__smeetz-data-migration",
}

// export enum Checkpoints {
//   timeslot_availabilities = "timeslots_availability",
//   retail_availabilities = "retail_availability",
// }

type AnyProps = Record<string, unknown>;

class Storage {
  public getLocalStorageItem(prop: string): string | null {
    const item = localStorage.getItem(prop);
    if (!item || item === "undefined") return null;
    return item;
  }

  public setLocalStorageItem(prop: string, value: string): void {
    return localStorage.setItem(prop, value);
  }

  public removeLocalStorageItem(prop: string) {
    return localStorage.removeItem(prop);
  }

  public getItem(prop: string): string | undefined {
    return Cookies.get(prop);
  }

  public setItem(
    prop: string,
    value: string | Date | AnyProps,
    options?: Cookies.CookieAttributes | undefined
  ): string | undefined {
    if (prop === "__smeetz-pos--auth-gql") {
      // lets add an expiry date to this cookie, expiry date in our graphql backend is 72 hours, we will use 48 hours
      // in 48 hours the cookie will be automatically removed by the browser and POS will do a refresh
      // this way we will never have a user logged in into POS but having an expired gql token
      options = { expires: 2 };
    }
    return Cookies.set(prop, value, options);
  }

  // eslint-disable-next-line
  public getJSON(prop = ""): any {
    const data: string = this.getItem(prop)!;
    return JSON.parse(data);
  }

  public remove(
    prop: string,
    options?: Cookies.CookieAttributes | undefined
  ): void {
    return Cookies.remove(prop, options);
  }

  public clearAll() {
    const cookies = Cookies.get();
    for (const name of Object.keys(cookies)) {
      Cookies.remove(name);
    }
  }

  public clearTokens(): void {
    this.remove(StorageKeys.AuthAccessToken);
    this.remove(StorageKeys.AuthRefreshToken);
    this.remove(StorageKeys.AuthExpiresIn);
    this.remove(StorageKeys.SmtzAuthToken);

    // clearing b2b tokens as well
    this.remove(StorageKeys.AuthAccessTokenB2B);
    this.remove(StorageKeys.AuthRefreshTokenB2B);
    this.remove(StorageKeys.AuthExpiresInB2B);
  }
}

export default new Storage();
